import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';

export default function Payments() {
  const { user } = useAuth();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user?.id) {
      setError('Не авторизован');
      setLoading(false);
      return;
    }

    fetch(`/api/profile/${user.id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => res.ok ? res.json() : Promise.reject(res.statusText))
      .then(data => setPayments(data.payments || []))
      .catch(err => setError(err.message || 'Ошибка загрузки'))
      .finally(() => setLoading(false));
  }, [user?.id]);

  return (
    <div className="min-h-screen bg-[#1b1b1b] text-[#dedede] font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      <section className="py-24 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-8">
          <div className="mb-20 text-center">
            <span className="text-[11px] font-black uppercase tracking-[0.5em] text-primary">Платежи</span>
            <h1 className="text-5xl md:text-6xl font-black uppercase tracking-tighter mt-2">
              История платежей
            </h1>
          </div>

          <div className="glass-panel rounded-[28px] p-8 md:p-12 max-w-3xl mx-auto shadow-[0_0_60px_rgba(184,151,90,0.15)]">
            {loading ? (
              <p className="text-center text-slate-400 text-xl">Загрузка...</p>
            ) : error ? (
              <p className="text-center text-red-500 text-xl">{error}</p>
            ) : payments.length === 0 ? (
              <p className="text-center text-slate-400 text-lg">Оплат пока нет</p>
            ) : (
              <div className="space-y-6">
                {payments.map((p, i) => (
                  <div key={i} className="glass-card rounded-xl p-6 flex justify-between items-center">
                    <div>
                      <p className="font-medium">{p.date}</p>
                    </div>
                    <p className="text-green-500 font-black text-xl">{p.amount} ₽</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      <BottomNav />
    </div>
  );
}